export const SEV = {
  CRITICAL: { cls: "bg-rose-600 text-white border-rose-600", soft: "bg-rose-50 text-rose-700 border-rose-200", dot: "bg-rose-600" },
  HIGH: { cls: "bg-amber-500 text-white border-amber-500", soft: "bg-amber-50 text-amber-700 border-amber-200", dot: "bg-amber-500" },
  ATTENTION: { cls: "bg-sky-600 text-white border-sky-600", soft: "bg-sky-50 text-sky-700 border-sky-200", dot: "bg-sky-500" },
  INFO: { cls: "bg-slate-600 text-white border-slate-600", soft: "bg-slate-50 text-slate-600 border-slate-200", dot: "bg-slate-400" },
};

export const STATUS_CLS = {
  OPEN: "bg-white text-slate-700 border-slate-300",
  IN_PROGRESS: "bg-indigo-50 text-indigo-700 border-indigo-200",
  ESCALATED: "bg-rose-50 text-rose-700 border-rose-200",
  RESOLVED: "bg-emerald-50 text-emerald-700 border-emerald-200",
  DISMISSED: "bg-slate-100 text-slate-500 border-slate-200",
};

export const CAT_LABEL = { commercial: "Commercial", procurement: "Procurement", operations: "Operations", finance: "Finance", service: "Service", itam: "ITAM / Devices" };

export const inr = (v) => (v == null ? "" : `₹${Number(v).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`);

export const fmtDate = (d) => {
  if (!d) return "—";
  const x = new Date(d);
  return Number.isNaN(x.getTime()) ? d : x.toLocaleDateString("en-IN", { day: "2-digit", month: "short" });
};

export const fmtWhen = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
};

export const shortOwner = (o) => (!o ? "—" : o.includes("@") ? o.split("@")[0] : o);
